// École Nid Douillet - 404 Not Found Page

import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 rounded-xl bg-red-100 flex items-center justify-center">
            <span className="text-red-600 font-bold text-2xl">404</span>
          </div>
          <h1 className="mt-6 text-3xl font-bold text-neutral-900">
            Page non trouvée
          </h1>
          <p className="mt-2 text-sm text-neutral-600">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <div className="mt-6">
            <Link
              to="/dashboard"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700"
            >
              <HomeIcon className="mr-2 h-4 w-4" />
              Retour au tableau de bord
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
